import {cleanPipes, titleCase, replace} from '../../replacements.js';
import { Popup } from './Popup.js';
import { CreaturePopup } from './CreaturePopUp.js';
import { exportSpells, conditionsExport, diseasesExport, statusExport, sortedMonsterList } from '../../constants.js';

const allHovers = [...exportSpells, ...conditionsExport, ...diseasesExport, ...statusExport, ...sortedMonsterList]
const allHoversSeperated = [exportSpells, conditionsExport, diseasesExport, statusExport, sortedMonsterList]

const popoverKeys = ["spell", "condition", "disease", "status", "hover", "creature"]
 


const getFormattedObj = (key, findKey, cPipes = false, tCase = true, bold = true) => {

    let sliceCount = findKey.length + 1
    let element;
    let valueName;
    let search;
    if(key.startsWith(findKey)) {
        element = key.slice(sliceCount)
        valueName = element
    }

    if(element) {
        if(cPipes) {
            let elObj = cleanPipes(element)
            search = elObj.name
            element = elObj.textToBeShown
            valueName = cleanPipes(valueName).textToBeShown
        }

        if(tCase) {
            element = element.toLowerCase()
            element = titleCase(element)
        }

        if(bold) {
            element = <strong>{element}</strong>
        }
    } else {
        return null
    }

    return {
        name: valueName,
        search: search,
        valueType: findKey,
        element: element
    }
}

const regex = /[a-z]+\|[a-z]+/gi;

const creatureCleanPipes = (creatureWithPipes) => {
    let matches = creatureWithPipes.match(regex)

    let name;
    let sourceShort;
    let keys = creatureWithPipes.split('|')
    if(matches?.length > 0) {
        name = keys[0].toLowerCase(); 
        sourceShort = keys[1].toLowerCase();
    } else {
        name = keys[0].toLowerCase(); 
        sourceShort = null;
    }
    
    return {name, sourceShort}
}


const filterName = (elementObj) => {
    let indexOfType = popoverKeys.indexOf(elementObj.valueType)


    // Filter over specific or over all if homebrewed creature with {@hover } (4) instead of specific type
    // @hover (4) is only used in homebrew so i dont know what it specifically is
    if(indexOfType === 4) {
        return allHovers.filter(hoverItem => hoverItem.name.toLowerCase() === elementObj.search.toLowerCase());
    } else if (indexOfType === 5) { // creature - could have pipes containing source
        let creatureNameSrc = creatureCleanPipes(elementObj.name)
        if(creatureNameSrc.sourceShort === null) {
            return sortedMonsterList.filter(hoverItem => hoverItem.name.toLowerCase() === creatureNameSrc.name);
        } else {
            return sortedMonsterList.filter(hoverItem => hoverItem.name.toLowerCase() === creatureNameSrc.name && hoverItem.sourceShort.toLowerCase() === creatureNameSrc.sourceShort);
        }
    } else {
        return allHoversSeperated[indexOfType].filter(hoverItem => hoverItem.name.toLowerCase() === elementObj.search.toLowerCase());
    }
}

// Usage in a React Component
export const BoldifyReplace = ({ name, desc, handleSelectCreature=undefined }) => {
    const str = (name || desc || "").toString();
    if(str === "") return null;

    const formatPart = (part) => {
        // This is not in replace() becuase they are special
        if (part.startsWith("{@h}")) { return <strong>Hit: {part.slice(4)}</strong>; } 
        if (part.startsWith("{@hit ")) { return <strong>+{part.slice(6).replace("}", "")}</strong>; } 
        // Note can have nested {@abc }
        if (part.startsWith("{@note ")) { 
            return <BoldifyReplace name={'Note: ' + part.slice(6).slice(0,-1)} />; 
        } 

        const match = part.match(/^\{@(.*?)\}$/);

        if (!match) return <span>{part}</span>;
        const key = match[1];
        let elementObj;
        elementObj = popoverKeys.map((popKey) => getFormattedObj(key, popKey, !part.includes("@creature"))).find((obj) => obj !== null);
        
        // if its spell or condition, 
        if(elementObj) {
            
            if(popoverKeys.includes(elementObj.valueType)) {
                let isCreatureType = elementObj.valueType === "creature"

                const hoverMatches = filterName(elementObj)
                // If no spell found, dont do popup and return regular string
                if(hoverMatches.length === 0) {
                    return isCreatureType ? <b>{elementObj.name.split("|")[0]}</b> : elementObj.element
                } else if(isCreatureType) {
                    return <CreaturePopup creature={hoverMatches[0]} handleSelectCreature={handleSelectCreature} />
                } else {
                    // If 'hover' its homebrew so search through everything for a match, else search specific
                    return <Popup items={hoverMatches} elementObj={elementObj}/> 
                }

                
            }
        } else {
            // if {@x} was found i.e. bold a replace,
            let replaced = replace(key)
            if(replaced)
                return replaced
            else {
                return <span>{key} - !!!!If you see this let DmBuddy Nic know on Discord!!! - </span>;
            }
        }
    };

    const formattedString = str.split(/(\{@h\}\d+ |\{@hit \d+\} to hit|\{@note.*\}|{@.*?\})/)
        .map((part, index) => <span key={"highlighted" + index}>
                {formatPart(part)}
            </span>
        ); 

    return <span className={desc ? 'infoDesc' : ''}>{formattedString}</span>;
};